import { ICarrierApplicationEntityTypes } from 'types/graphqlTypes'

export const ENTITY_TYPE = {
  individual: 'Individual/sole proprietor or single member LLC',
  ccorp: 'C Corporation',
  scorp: 'S Corporation',
  partnership: 'Partnership',
  trust: 'Trust/Estate',
  llc: 'Limited Liability Company',
}

export const ENTITY_TYPE_OPTIONS = [
  {
    label: 'Individual/sole proprietor or single member LLC',
    value: ICarrierApplicationEntityTypes.individual,
  },
  {
    label: 'C Corporation',
    value: ICarrierApplicationEntityTypes.ccorp,
  },
  {
    label: 'S Corporation',
    value: ICarrierApplicationEntityTypes.scorp,
  },
  {
    label: 'Partnership',
    value: ICarrierApplicationEntityTypes.partnership,
  },
  {
    label: 'Trust/Estate',
    value: ICarrierApplicationEntityTypes.trust,
  },
  {
    label: 'Limited Liability Company',
    value: ICarrierApplicationEntityTypes.llc,
  },
]
